<template>
  <div>
    <v-row justify="center">
      <v-col xs="12" sm="8">
        <v-btn text v-for="(letter, i) in letters" @click="onLetterButton(letter)" :key="i"
               :color="getButtonColor(letter)">{{ letter }}
        </v-btn>
        <br>
        <v-btn @click="onResetFilter()" text color="accent">zur&uuml;cksetzen</v-btn>
        <div>Zurück zur <a :href="backURL">Hauptseite</a></div>
        <v-text-field label="Suchen" v-model="searchFilter"/>
      </v-col>
      <v-col xs="12" sm="4" class="hidden-xs-only">
        <v-img src="@/assets/Logo_Volkskultur_CMYK-1.jpg"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="4" md="4" lg="3" xl="2">
        <v-card class="word-list" height="35em">
          <v-card-text>
            <v-list>
              <v-progress-circular v-if="this.words == null" indeterminate color="primary" size="100"
                                   width="10"></v-progress-circular>
              <v-list-item-group v-else color="primary" mandatory v-model="selectedWord">
                <v-list-item v-for="(item, i) in wordsFiltered" :key="i" :value="item">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col sm="8" md="8" lg="9" xl="6">
        <v-row>
          <v-img src="@/assets/map.png" class="img-map" contain/>
        </v-row>
        <v-row class="justify-space-around row">
          <v-btn class="play-region" color="accent" @click="play('g')" :disabled="playButtonDisabled('g')">Gailtal
            <v-icon>mdi-play</v-icon>
          </v-btn>
          <v-btn class="play-region" color="accent" @click="play('r')" :disabled="playButtonDisabled('r')">Rosental
            <v-icon>mdi-play</v-icon>
          </v-btn>
          <v-btn class="play-region" color="accent" @click="play('j')" :disabled="playButtonDisabled('j')">Jauntal
            <v-icon>mdi-play</v-icon>
          </v-btn>
        </v-row>
        <v-row class="mt-6" align="center" justify="center">
          <v-card>
            <v-img src="@/assets/logo_woerterbuch_half.png" max-width="305" contain/>
            <v-card-text class="img-subtitle">
              Verfasst von Oswald Gutsmann,<br>
              veröffentlicht 1789 in Klagenfurt
            </v-card-text>
          </v-card>
          <v-spacer class="hidden-md-and-down"></v-spacer>
          <v-img class="hidden-md-and-down" src="@/assets/Slogan_KW_RGB-transparent_hoch-1.png" max-width="525"
                 contain/>
        </v-row>
      </v-col>
      <v-col lg="12" xl="4">
        <v-card>
          <v-card-title>Bedienungsanleitung</v-card-title>
          <v-card-text class="text-justify">
            <p>
              Dialekte haben nicht für jeden in der Schriftsprache vorkommenden Begriff ein Äquivalent.
              Aus diesem Grund sind in der Datenbank nur Begriffe enthalten, die typisch für diesen Dialekt sind.
            </p>
            <p>
              Im Feld <span class="primary_color">Suchen</span> kann gezielt nach deutschen Wörtern gesucht werden, die
              ein windisches Äquivalent haben.
            </p>
            <p>ODER</p>
            <p>
              man klickt auf den Anfangsbuchstaben über dem Feld <span class="primary_color">Suchen</span> und lässt
              sich anzeigen, welche Begriffe
              archiviert
              sind. Alternativ kann man auch mit dem Schieberegler die Datenbank „durchscrollen“, bis der gewünscht
              Begriff im
              Listenfeld angezeigt wird.
            </p>
            <p>
              Mit dem „Klick“ auf den gesuchten Begriff im Listenfeld wird mit den Täler-Buttons (Gail-, Jaun-,
              Rosental)
              farbig angezeigt, für welches Tal der windische Begriff in der Datenbank vorhanden ist. Klickt man den
              farbigen
              Button an, wird der gesuchte Begriff für das gewählte Tal „authentisch gesprochen“.
              Durch anklicken von <span class="primary_color">ZURÜCKSETZEN</span> kann die Suchauswahl zurückgesetzt
              werden.
            </p>
            <p>
              Wenn jemand einen Begriff kennt, der noch nicht in der Datenbank gespeichert ist, dann bitte unter der
              e-Mailadresse <a href="mailto:kaewin@kaerntnerwindische.com">kaewin@kaerntnerwindische.com</a> melden,
              damit er aufgenommen werden
              kann.
              Vielen Dank für Ihre Mitarbeit
            </p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" class="hidden-lg-and-up">
        <v-img src="@/assets/Slogan_KW_RGB-transparent_hoch-1.png"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-text class="text-justify">
            <p>
              Im Laufe der Geschichte sind viele Sprachen im Gebiet des heutigen Kärnten gesprochen worden.
              Nahezu alle sind verschwunden. Nur zwei sind übriggeblieben - Deutsch und Slowenisch.
              <br/>
              Jede Hochsprache hat ihre regionale Eigenart, Dialekt oder Mundart genannt.
              Den deut­ schen Dialekt nennt man bei uns Kärntnerisch und den slawischen Dialekt nennt man Windisch.
              Windisch wurde auch in den Herzogtümern Steiermark (Windische Mark) und Krain gesprochen.
              Umgangssprachlich wurde für Windisch im Herzogtum Krain auch der Begriff Krainerisch verwendet.
            </p>
            <p>
              Der Begriff „Windisch" wurde schon als Bezeichnung für die Sprache der ab dem 6. Jahrhundert hier
              eingewanderten Südslawen verwendet. Da die Slawen keine Schrift kannten, wurde deren Sprache nur mündlich
              überliefert. Dementsprechend spärlich sind Aufzeichnungen aus dieser Zeit vorhanden. Erst im Zuge der
              protestantischen Christianisierung ab dem 14. Jahr­ hundert wurden von evangelischen Missionaren (Truber)
              Bemühungen unternommen, dem Windischen eine Normierung (Regeln, Schriftzeichen) zu geben, um die Sprache
              in lateini­ scher Schrift abbilden zu können und so das „Wort Gottes" verbreiten zu können.
            </p>
            <p>
              Der Vielvölkerstaat Österreichische Monarchie kannte nur Deutsch als Amtssprache. Erst mit dem
              aufkeimenden Nationalismus im 18. Jahrhundert war man dazu übergegangen die örtlichen Redeweisen zu
              berücksichtigen. So sind damals besonders im sich bildenden Panslawis­ mus Bestrebungen entstanden,
              Gesetze auch in anderen Sprachen zu veröffentlichen. Und seit dieser Zeit (Bartholomäus Kopitar, einer der
              Begründer der Slawistik, 1809 in deutscher Sprache veröffentlichte Grammatik der slavischen Sprache in den
              Herzogtümern Kärnten, Krain und Steiermark) ist „Slowenisch" zu einem eigenständigen Begriff und
              verbindenden Nationalsymbol geworden.
            </p>
            <p>Dialekt - ganz egal welcher - wird immer seltener gesprochen, insbesondere im ländlichen Raum. Dialekt
              wird üblicherweise mündlich überliefert. Erst in der Schule wird auf Schriftsprache Wert gelegt. </p>
            <p>Trotzdem ist Dialekt ein Teil unserer Geschichte und deshalb schützenswert. Für den Kärntner- und
              Steirerdialekt fühlt sich die Presse verantwortlich (leck' Buckl), für Windisch der Verein der Kärntner
              Windischen.</p>
            <p>Um Dialektbegriffe schriftlich festzuhalten bedient man sich des Hilfsmittels der Sonderzeichen, die man
              aber erst definieren muss. Ein weiteres Hilfsmittel, um die Aussprache wiederzugeben, ist die Lautschrift.
              Die Lautschrift kann die spezifische Aussprache von Dialektbegriffen nur unzureichend wiedergeben.
              Erschwerend kommt hinzu, dass, wie das Beispiel Windisch zeigt, noch tälerspezifische Eigenheiten in der
              Aussprache berücksichtigt werden müssen.</p>
            <p>Um trotzdem ein umfassendes Bild der Nachwelt erhalten zu können, hat sich unser Verein bei der
              Archivierung des windischen Dialektes der digitalen Methode bedient und die Begriffe phonetisch
              festgehalten. Die Idee, den windischen Sprachschatz zu digitalisieren und der Nachwelt zu erhalten, hat
              nachträglich eine weitere Besonderheit zutage gefördert.</p>
            <p>Noch nie konnten auf einfache Weise die teilweise doch sehr unterschiedlichen Eigenheiten der Dialekte
              aus den 3 Tälern Gail-, Jaun- und Rosental im direkten Vergleich hörbar gemacht werden, jetzt ist es
              möglich.</p>
            <p>Das Projekt kann man nicht als abgeschlossen betrachten, denn eigentlich ist es der Anfang einer
              kontinuierlichen Fortschreibung von Begriffen, die es wert sind aufgezeichnet zu werden.</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "MainView",

  beforeMount() {
    for (let i = "A".charCodeAt(0); i <= "Z".charCodeAt(0); i++) {
      this.letters.push(String.fromCharCode(i))
    }
  },

  async created() {
    this.words = await this.getWords();
    this.selectedWord = this.words[0];
    this.wordsFiltered = this.words;
    console.log("words", this.words);
  },

  data: () => ({
    letterFilter: null,
    searchFilter: "",
    words: null,
    wordsFiltered: [],
    selectedWord: null,
    letters: [],
    backURL: "https://www.kaerntnerwindische.com",
    audio: new Audio(),
  }),

  watch: {
    searchFilter() {
      this.applyFilter();
    }
  },

  methods: {
    async getWords() {
      return await this.$wordService.getAllWords();
    },

    play(region) {
      if (this.selectedWord != null) {
        let url = "";
        switch (region) {
          case 'g':
            url = this.selectedWord.urlGt;
            break;
          case 'r':
            url = this.selectedWord.urlRt;
            break;
          case 'j':
            url = this.selectedWord.urlJt;
            break;
        }
        this.audio.src = url;
        this.audio.play();
      }
    },

    playButtonDisabled(region) {
      if (this.selectedWord === null) {
        return true;
      }
      let url = null;
      switch (region) {
        case 'g':
          url = this.selectedWord.urlGt;
          break;
        case 'r':
          url = this.selectedWord.urlRt;
          break;
        case 'j':
          url = this.selectedWord.urlJt;
          break;
      }

      return url === null;
    },

    onLetterButton(letter) {
      if (this.letterFilter !== letter) {
        this.letterFilter = letter;
        this.searchFilter = "";
        this.applyFilter();
      }
    },

    onResetFilter() {
      this.letterFilter = null;
      this.searchFilter = "";
      this.applyFilter();
    },

    getButtonColor(letter) {
      return this.letterFilter === letter ? "primary" : "";
    },

    applyFilter() {
      let newFiltered = this.words;

      const letterFilterNormalized = this.letterFilter === null ? "" : this.letterFilter.toLowerCase();
      const searchFilterNormalized = this.searchFilter === null ? "" : this.searchFilter.trim().toLowerCase();

      if (!searchFilterNormalized.startsWith(letterFilterNormalized)) {
        newFiltered = newFiltered.filter(x => x.title.toLowerCase().startsWith(letterFilterNormalized));
      }

      if (searchFilterNormalized !== "") {
        let searchFiltered = newFiltered.filter(x => x.title.toLowerCase().startsWith(searchFilterNormalized));
        if (searchFilterNormalized.length !== 0) {
          newFiltered = searchFiltered;
        }
      }

      this.wordsFiltered = newFiltered;
      this.selectedWord = null;
    }
  }
}
</script>
<style lang="scss" scoped>

.row {
  display: flex;
}

.column {
  flex: 1
}

.word-list {
  overflow-y: auto;
  margin-right: 1em;
}

.img-map {
  max-height: 270px;
}

.play-region {
  width: 8em;
}

.primary_color {
  color: var(--v-primary-base);
}

.img-subtitle {
  padding: 4px;
  line-height: 1.15rem;
}
</style>
